<span class="p-error" *ngIf="control && control.invalid && control.touched">
  <ng-container *ngIf="control.errors | keyvalue as errors">
    <ng-container *ngIf="!errorTemplates[errors[0]?.key]; else errorTemplate">
      <ng-container
        *ngIf="(errors[0]?.value | typeof) !== 'string'; else dynamicTemplate"
        [ngTemplateOutlet]="staticErrorTemplate"
        [ngTemplateOutletContext]="{ $implicit: errors[0] }"
      />

      <ng-template #dynamicTemplate>
        {{ errors[0]?.value | propertyTranslator | translate }}
      </ng-template>
    </ng-container>

    <ng-template
      #errorTemplate
      [ngTemplateOutlet]="errorTemplates[errors[0]?.key]"
    />
  </ng-container>
</span>

<ng-template #staticErrorTemplate let-error>
  {{ messages[error?.key] ?? defaultMessages[error?.key] | translate }}

  <ng-container [ngSwitch]="error?.key">
    <ng-container *ngSwitchCase="'minlength'">
      <strong> {{ error.value?.requiredLength }} </strong>
      <ng-container *ngIf="error.value?.locales?.length">
        <span>{{ "error.CHARS" | translate }}</span>
        <span> {{ "error.IN" | translate }}</span>
        {{ error.value?.locales | localeLanguageName }}
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'maxlength'">
      <strong> {{ error.value?.requiredLength }} </strong>
      <ng-container *ngIf="error.value?.locales?.length">
        <span>{{ "error.CHARS" | translate }}</span>
        <span> {{ "error.IN" | translate }}</span>
        {{ error.value?.locales | localeLanguageName }}
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'minFile'">
      {{ "error.minFile" | translate : { arg: error.value?.requiredLength } }}
    </ng-container>

    <ng-container *ngSwitchCase="'min'">
      <strong> {{ error.value?.min }} </strong>
    </ng-container>

    <ng-container *ngSwitchCase="'max'">
      <strong> {{ error.value?.max }} </strong>
    </ng-container>

    <ng-container *ngSwitchCase="'minDate'">
      {{
        error.value?.min || field?.validations?.min.value
          | timeZoneDate : dateFormat : timeZoneOffset
      }}
    </ng-container>

    <ng-container *ngSwitchCase="'maxDate'">
      {{
        error.value?.max || field?.validations?.max.value
          | timeZoneDate : dateFormat : timeZoneOffset
      }}
    </ng-container>

    <ng-container *ngSwitchCase="'minTime'">
      {{
        error.value?.min || field?.validations?.min?.value
          | timeZoneDate : timeFormat : timeZoneOffset
      }}
    </ng-container>

    <ng-container *ngSwitchCase="'maxTime'">
      {{
        error.value?.max || field?.validations?.max?.value
          | timeZoneDate : timeFormat : timeZoneOffset
      }}
    </ng-container>

    <ng-container *ngSwitchCase="'minDateTime'">
      {{
        error.value?.min || field?.validations?.min?.value
          | timeZoneDate : dateTimeFormat : timeZoneOffset
      }}
    </ng-container>

    <ng-container *ngSwitchCase="'maxDateTime'">
      {{
        error.value?.max || field?.validations?.max?.value
          | timeZoneDate : dateTimeFormat : timeZoneOffset
      }}
    </ng-container>

    <ng-container *ngSwitchCase="'minMonth'">
      {{ error.value?.min || control.errors.minMonth | translate }}
    </ng-container>

    <ng-container *ngSwitchCase="'maxMonth'">
      {{ error.value?.max || control.errors.maxMonth | translate }}
    </ng-container>
    <ng-container *ngSwitchCase="'uniqueness'">
      <ng-container *ngIf="error.value?.locales?.length">
        <span>{{ "error.IN" | translate }}</span>
        {{ error.value?.locales | localeLanguageName }}
      </ng-container>
    </ng-container>

    @if (error.key.startsWith("customError")) {
    {{ error.value | propertyTranslator }}
    }
  </ng-container>
</ng-template>
